import { render, staticRenderFns } from "./NewBlogCarousel.vue?vue&type=template&id=6af9d4d6"
import script from "./NewBlogCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewBlogCarousel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NewBlogCarousel.vue?vue&type=style&index=0&id=6af9d4d6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports